export enum AppSetting {
  MaintenanceIdleIntervalMinutes = 205,
  MaintenanceActiveIntervalMinutes = 206,
  MaintenanceReminderFromMinutes = 213,
  MaintenanceActiveFromUtcFormat = 217,
  MaintenanceActiveToUtcFormat = 218,
  DeliveryNoteB2CUrlTemplate = 2151,
  DeliveryNoteB2BUrlTemplate = 2161,
}
